import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITestingContinuousRunService = ( createDecorator('testingContinuousRunService'));
export { ITestingContinuousRunService };
